import React, { FunctionComponent } from "react"
import HRRService from "../utils/HRRService"
import { CSVLink } from "react-csv"
import IconBuilder from "src/utilities/iconBuilder/IconBuilder"
import snackBar from "src/utilities/snackBar/SnackBar"
import { OverlayTrigger } from "react-bootstrap"
import "./HRRDownloadReport.css"

const HRRDownloadReport: FunctionComponent<{}> = () => {

    const { manageState, nameReport, HRRServiceTooltip, state } = HRRService
    const { employeeReport, selectedReport } = state
    //@ts-ignore
    const fileName = nameReport(selectedReport)



    return (
        <div className="HRRDownloadReport">
            <div className="HRRDownloadReportUpper">
                <p>Ready</p>
            </div>
            <div className="HRRDownloadReportLower">
                <div className="HRRDownloadReportCSVIcon">
                    <IconBuilder extension="csv" size={96}></IconBuilder>
                </div>
                <div className="HRRDownloadReportOptions">
                    <div className="HRRDownloadReportDownloadBtn">
                        <OverlayTrigger placement="left" overlay={HRRServiceTooltip("Download report")}>
                            <CSVLink
                                data={employeeReport}
                                filename={fileName}
                            >
                                <span className="material-icons" onClick={() => {
                                    snackBar({ type: "primary", text: `downloaded ${fileName}`, timeout: 3000 })
                                }}>download</span>
                            </CSVLink>
                        </OverlayTrigger>
                    </div>
                    <div className="HRRDownloadReportViewBtn">
                        <OverlayTrigger placement="right" overlay={HRRServiceTooltip("View report")}>
                            <span onClick={() => manageState([{ key: "viewReport", value: true }])} className="material-icons">visibility</span>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default HRRDownloadReport